import { createStyles } from "@mantine/core";
import { palette }      from "_styles/theme";

export default createStyles ( theme => {

	const commonContainer = {
		marginBottom    : "1.5rem",
		outline         : theme.other.darkMode ? "none" : `solid 1px ${ theme.other.colors.border.primary }`,
		borderRadius    : "8px",
		backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : theme.other.paletteNew.secondaryWhite,

		"&:hover": {
			borderRadius : "10px",
			outline      : `solid 3px ${ theme.other.paletteNew.primaryDarkBlue }`
		}
	};

	return {
		optionContainer: {
			...commonContainer
		},
		flexContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "space-between",
			padding        : "1rem",
			width          : "100%"
		},
		avatar     : { ...theme.other.rooterAvatars.size40 },
		optionText : {
			fontSize: "1.4rem"
		}
	};
} );

